import { render, staticRenderFns } from "./ExpandImage.vue?vue&type=template&id=81198d3c&scoped=true"
import script from "./ExpandImage.vue?vue&type=script&lang=js"
export * from "./ExpandImage.vue?vue&type=script&lang=js"
import style0 from "./ExpandImage.vue?vue&type=style&index=0&id=81198d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81198d3c",
  null
  
)

export default component.exports